import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';

export interface IButtonCloseControllerOptions {
    onClick: () => void;
}

export class ButtonCloseController extends AnimationBaseController {
    $model: any;

    public constructor(
        @Inject private _options: IButtonCloseControllerOptions
    ) {
        super('ButtonCloseController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {},
            onTap: () => {
                this._options.onClick();
            },
            onPointerDown: () => {
                this.gotoAndStop('down');
            },
            onPointerUp: () => {
                this.gotoAndStop('up');
            },
            onPointerOut: () => {
                this.gotoAndStop('up');
            },
            onPointerOver: () => {
                this.gotoAndStop('over');
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop('up');
    }
}
